import request from '@/utils/request'
import { getToken } from '@/utils/auth'

// SSE 流式对话（使用 fetch + ReadableStream，不经过 axios）
// signal: 可选的 AbortSignal，用于取消请求
export function chatStream(sessionId, content, signal) {
  const token = getToken()
  return fetch('/api/ai/chat', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify({ sessionId, content }),
    signal: signal || undefined
  })
}

// 获取会话列表
export function getSessionList() {
  return request({ url: '/ai/sessions', method: 'get' })
}

// 新建会话
export function createSession(data) {
  return request({ url: '/ai/sessions', method: 'post', data })
}

// 删除会话
export function deleteSession(id) {
  return request({ url: '/ai/sessions/' + id, method: 'delete' })
}

// 获取会话历史消息
export function getSessionHistory(id) {
  return request({ url: '/ai/sessions/' + id + '/history', method: 'get' })
}

// 获取快捷指令
export function getQuickCommands() {
  return request({ url: '/ai/quick-commands', method: 'get' })
}
